<template>
    <div class="carouselDIV">
        <!--轮播图区域-->
        <el-carousel :interval="5000" arrow="always" :height="bannerHeight + 'px'">
            <el-carousel-item v-for="item in imgList" :key="item.id">
                <img class="img" :src="item.idView" >
            </el-carousel-item>
        </el-carousel>
        <!--why区域-->
        <div id="why_area">
            <div id="why_title">
                <span id="why">为何选择我们？</span>
                <div id="why_line"></div>
            </div>
            <el-row type="flex" justify="space-around">
                <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="4" v-for="item in whyList" :key="item.id"
                        align="center">
                    <img :src="item.idView" class="image">
                    <span class="why_msg">{{item.msg}}</span>
                </el-col>
            </el-row>
        </div>


    </div>
</template>

<script>
  export default {
    data() {
      return {
        bannerHeight: "",
        imgList: [
          {id: 0, idView: require('../assets/img/banner1.jpg')},
          {id: 1, idView: require('../assets/img/banner2.jpg')},
          {id: 2, idView: require('../assets/img/banner3.jpg')}
        ],
        whyList: [
          {id: 0, idView: require('../assets/img/why1.png'), msg: '专业开发团队'},
          {id: 1, idView: require('../assets/img/why2.png'), msg: '前沿科学技术'},
          {id: 2, idView: require('../assets/img/why3.png'), msg: '美学设计风格'},
          {id: 3, idView: require('../assets/img/why4.png'), msg: '协助安装部署'},
        ]

      }
    },
    created: function () {
      this.bannerHeight = document.documentElement.clientWidth/2
      // if(document.documentElement.clientWidth > 640){
      //   this.bannerHeight = 610
      // }else{
      //   this.bannerHeight = 220
      // }
    },
    mounted() {
      window.addEventListener(
        "resize",
        () => {
          this.bannerHeight = document.documentElement.clientWidth/2
        },
        false
      );
    },

  }
</script>

<style lang="less">
    .carouselDIV {
        .img {
          height: 100%;
          width: 100%;
        }

        .el-carousel__arrow--left {
            left: 7%;
        }

        .el-carousel__arrow--right {
            right: 7%;
        }

        .el-carousel__arrow {
            width: 72px;
            height: 72px;
            font-size: 30px;
            text-shadow: 0 1px 2px rgba(0, 0, 0, .6);
        }
    }

    #why_area {
        padding: 120px 200px;

        #why_title {
            text-align: center;
            margin-bottom: 140px;
        }

        #why {
            font-size: 34px;
            color: #595757;
        }

        #why_line {
            margin: 0 auto;
            margin-top: 20px;
            width: 100px;
            height: 4px;
            background-color: #e5d276;
        }
        .el-row {
         text-align: center;
        }
        .image {
            margin: 0 auto;
            height: 87px;
            width: 87px;
            margin-bottom: 20px;
        }
        .why_msg {
            display: block;
            font-size: 20px;
            color: #595757;
        }
    }


</style>
